import { render, staticRenderFns } from "./Supplementary.vue?vue&type=template&id=5dd0417b&"
import script from "./Supplementary.vue?vue&type=script&lang=js&"
export * from "./Supplementary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports